import { Link } from 'react-router-dom';
import { useCookieConsent } from '../context/CookieConsentContext';
import { Button } from './ComponentLibrary';
import './CookieConsentBanner.css';

function CookieConsentBanner() {
  const { hasDecided, isSettingsOpen, acceptAll, rejectNonEssential, openSettings } = useCookieConsent();

  // Hide while the settings modal is open, not just once a decision has
  // been made - otherwise the banner sits behind the modal and, on short
  // mobile viewports, its buttons can overlap the modal's own footer.
  if (hasDecided || isSettingsOpen) {
    return null;
  }

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <div className="cookie-banner__icon" aria-hidden="true">
        🍪
      </div>
      <div className="cookie-banner__body">
        <p>
          We use cookies to keep you signed in and, with your permission, to understand site
          usage. Read our <Link to="/cookie-policy">Cookie Policy</Link> and{' '}
          <Link to="/privacy">Privacy Policy</Link>.
        </p>
      </div>
      <div className="cookie-banner__actions">
        <Button variant="text" onClick={openSettings}>
          Manage Preferences
        </Button>
        <Button variant="secondary" onClick={rejectNonEssential}>
          Reject Non-Essential
        </Button>
        <Button variant="primary" onClick={acceptAll}>
          Accept All
        </Button>
      </div>
    </div>
  );
}

export default CookieConsentBanner;
